import _SvgIcon from "@mui/material/SvgIcon";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
export function DirectionStepIcon(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon, _extends({
    viewBox: "0 0 10 13"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1.59729 11.983V1.35217L8.60492 5.32584L1.59729 8.88666",
    stroke: "currentColor",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 11.983H3.14313",
    stroke: "currentColor",
    strokeMiterlimit: "10"
  }));
}